import React from "react";
interface ArrowIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
  rotate?: "left" | "up" | "right" | "down";
  color?: string;
  transition?: boolean;
  className?: string;
  onClick?: () => void;
}

const ArrowIcon: React.FC<ArrowIconProps> = ({
  size = 20,
  rotate = "left",
  color = "#1E1E1E",
  transition,
  onClick,
  className,
  ...props
}) => {
  const getRotateDeg = (val: "left" | "up" | "right" | "down"): string => {
    switch (val) {
      case "left":
        return "0";
      case "up":
        return "90";
      case "right":
        return "180";
      default:
        return "270";
    }
  };

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transition: transition ? "transform 0.2s ease-in-out" : "",
        transform: `rotate(${getRotateDeg(rotate)}deg)`,
      }}
      className={className}
      onClick={onClick}
      {...props}
    >
      <path
        d="M7.97435 4.94167L2.91602 10L7.97435 15.0583"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0836 10H3.05859"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowIcon;
